import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@store/authStore'
import { SUPPORT_QUERY_KEYS, supportApi } from '@api/endpoints/support'

/**
 * The Support hub's counts: the nav badge and the tab counts share this one query.
 *
 * Polled once a minute like the notification count, and invalidated wherever a ticket or suggestion
 * changes — creating, commenting, closing, a moderator acting (via the notice listener), submitting
 * or withdrawing a suggestion — so the badge does not wait for the poll.
 */
export function useSupportSummary() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return useQuery({
    queryKey: SUPPORT_QUERY_KEYS.summary,
    queryFn: supportApi.getSummary,
    enabled: isAuthenticated,
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
